"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatName;
/**
 * Format event value names to kebab case for use in IRI's.
 *
 * @param {String} name
 * @return {String} The formatted name.
 */
function formatName(name) {
  if (!name) return '';
  return name.replace(/\s+/g, '-').toLowerCase();
}
module.exports = exports.default;